import { BaseModel } from '@/shared/types/base.model';
import { CategoryField } from './category-field.model';

export class Category extends BaseModel {
  fields?: CategoryField[];
  constructor(public title?: string, public type?: string) {
    super();
  }
}
